import React, { useEffect, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, CheckIcon } from 'lucide-react';
export const ProductCategory = ({
  category,
  products,
  onBack,
  onProductDetails
}) => {
  const [selectedItems, setSelectedItems] = useState({});
  const categoryTitles = {
    checking: 'Checking accounts',
    savings: 'Savings accounts',
    loans: 'Loan options',
    certificates: 'Certificate options'
  };
  // Listen for add-to-cart events to update the selected items
  useEffect(() => {
    const handleAddToCart = event => {
      const {
        type,
        product
      } = event.detail;
      // Only update if the added product is from the current category
      if (type === category) {
        // Find the index of the product in the products array
        const productIndex = products.findIndex(p => p.name === product.name);
        if (productIndex !== -1) {
          setSelectedItems(prev => ({
            ...prev,
            [productIndex.toString()]: true
          }));
        }
      }
    };
    window.addEventListener('add-to-cart', handleAddToCart);
    return () => window.removeEventListener('add-to-cart', handleAddToCart);
  }, [category, products]);
  const handleProductSelect = productId => {
    setSelectedItems(prev => ({
      ...prev,
      [productId]: !prev[productId]
    }));
  };
  const handleNext = () => {
    // Get the selected products
    const selectedProducts = Object.keys(selectedItems).filter(id => selectedItems[id]).map(id => products.find((p, index) => index.toString() === id));
    // Add selected products to cart and navigate to cart confirmation
    selectedProducts.forEach(product => {
      if (product) {
        window.dispatchEvent(new CustomEvent('add-to-cart', {
          detail: {
            type: category,
            product
          }
        }));
      }
    });
    // Go back to trigger the cart confirmation flow
    onBack();
  };
  return <div className="flex flex-col p-6 flex-grow" data-id="element-435">
      <div className="flex items-center mb-6" data-id="element-436">
        <button onClick={onBack} className="mr-4" data-id="element-437">
          <ChevronLeftIcon size={24} data-id="element-438" />
        </button>
      </div>
      <h1 className="text-2xl font-bold mb-6" data-id="element-439">{categoryTitles[category]}</h1>
      {products.map((product, index) => <div key={index} className="border rounded-lg p-4 mb-4" data-id="element-440">
          <div className="flex justify-between items-start" data-id="element-441">
            <div className="flex-1" data-id="element-442">
              <h3 className="font-bold" data-id="element-443">{product.name}</h3>
              <p className="text-gray-700 text-sm mb-1" data-id="element-444">
                {product.description}
              </p>
              <button className="text-[#5c5cf5] text-sm flex items-center" onClick={() => onProductDetails(product)} data-id="element-445">
                Learn more <ChevronRightIcon size={14} className="ml-1" data-id="element-446" />
              </button>
            </div>
            <div className={`w-6 h-6 rounded-full flex items-center justify-center cursor-pointer ${selectedItems[index] ? 'bg-[#5c5cf5]' : 'border border-gray-300'}`} onClick={() => handleProductSelect(index.toString())} data-id="element-447">
              {selectedItems[index] && <CheckIcon size={16} className="text-white" data-id="element-448" />}
            </div>
          </div>
        </div>)}
      <div className="mt-auto" data-id="element-449">
        <button className="w-full bg-[#5c5cf5] text-white py-3 rounded-full font-medium" onClick={handleNext} data-id="element-450">
          Next
        </button>
      </div>
    </div>;
};